/**
 * 阶段计划改期要不要写原因——前端这一份和后端 plan-node-reschedule.ts 同一套判据，
 * 只用来决定「弹不弹窗」；拦截的权威在后端（少传原因是 400）。
 *
 *   · 原来没有计划完成日 → 补排期，不问；
 *   · 节点已了结（完成 / 已批准 / 不适用 / 已取消，或填了实际完成）→ 记账，不问；
 *   · 新旧是同一天 → 没改，不问；
 *   · 其余（推后、提前、清空）都问。
 */
const SETTLED = new Set(['completed', 'approved', 'not_applicable', 'cancelled']);

export interface RescheduleSubjectLike {
  planEnd: string | null;
  status: string;
  actualEnd: string | null;
}

/** 值可能是 'YYYY-MM-DD'、'2026-08-03T23:59:59+08:00' 或 UTC ISO；前两种取前十位，UTC 的按上海折算 */
export function dayOf(value: string | null | undefined): string | null {
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}(T|$)/u.test(value) && !/Z$/u.test(value)) return value.slice(0, 10);
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Date(parsed.getTime() + 8 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function dayDiff(fromDay: string, toDay: string): number {
  const at = (day: string) => Date.UTC(Number(day.slice(0, 4)), Number(day.slice(5, 7)) - 1, Number(day.slice(8, 10)));
  return Math.round((at(toDay) - at(fromDay)) / 86_400_000);
}

export function nodeIsSettled(task: Pick<RescheduleSubjectLike, 'status' | 'actualEnd'>): boolean {
  return Boolean(task.actualEnd) || SETTLED.has(task.status);
}

/** nextEndDay：新的计划完成（YYYY-MM-DD），清空传 null */
export function nodeNeedsRescheduleReason(task: RescheduleSubjectLike, nextEndDay: string | null): boolean {
  const fromDay = dayOf(task.planEnd);
  if (!fromDay) return false;
  if (nodeIsSettled(task)) return false;
  const toDay = dayOf(nextEndDay);
  if (!toDay) return true;
  return toDay !== fromDay;
}

export interface RescheduleAnswer {
  category: string;
  reason: string;
}

/** 带原因的那三个字段，直接展开进 PATCH 的 payload */
export function rescheduleFields(answer: RescheduleAnswer, source: string): Record<string, string> {
  return { rescheduleCategory: answer.category, rescheduleReason: answer.reason, rescheduleSource: source };
}
